import { Layout } from 'plotly.js-dist-min';

export enum GraphType {
  BAR_CHART = 'bar-chart',
  FILLED_AREA_PLOT = 'filled-area-plot',
  LINE_CHART = 'line-chart',
  SCATTER_CHART = 'scatter-chart'
}
export enum GraphListType {
  Resource_Compution_CPU_Usage = 'Resource Compution-CPU Usage',
  Module_Restart_Timeline = 'Module Restart Timeline',
  Resource_Compution_Memory_Usage = 'Resource Compution-Memory Usage',

}

export enum GraphValueFormat {
  PERCENTAGE = 'percentage',
  MEMORY = 'memory',
  TRAFFIC = 'traffic',
  INTEGER_DIGIT = 'integer-digit',
  FRACTION_DIGIT = 'fraction-digit',
  TIME ='time'
}

export type GraphMetricsId = 'hostSystemOverview' | 'hostCpuUsage' | 'hostLoad' | 'hostMemoryUsage' | 'hostNetworkTraffic' | 'edgeAgent_module_start_total' | 'edgeAgent_used_cpu_percent' | 'edgeAgent_used_memory_bytes' | 'peripheralOverview' | 'default';

export type GraphMetricsIdV1 = 'hostSystemOverview' | 'host CPU usage' | 'host CPU process time' |'host network in' |'host network out'| 'host CPU usage by core'|'host CPU usage by mode' |'hostLoad' | 'host memory usage'| 'host swap memory usage'|'node_memory_Active_bytes'|'node_memory_Inactive_bytes' | 'hostNetworkTraffic' | 'edgeAgent_module_start_total' | 'edgeAgent_used_cpu_percent' | 'edgeAgent_used_memory_bytes' | 'peripheralOverview' | 'default';


export interface GraphMetrics {
  id: GraphMetricsId;
  label?: string;
  series: GraphMetricsSeries[];
}

export interface GraphMetricsSeries {
  id: string;
  data: {
    timestamp: number;
    value: number | null;
  }[];
}

export interface GraphMetricsV1 {
  id: GraphMetricsId;
  label?: string;
  series: GraphMetricsSeriesV1[];
}

export interface GraphMetricsSeriesV1 {
  labels:string;
  edgeDeviceId?:string;
  id: string;
  data: {
    time: number;
    value: number | null;
  }[];
}

export interface GraphList {
  id: GraphMetricsId;
  title: string;
  titleSuffix?: string;
  graphType: GraphType;
  content: GraphMetricsSeries[];
  layout: Partial<Layout>;
  valueFormat: GraphValueFormat;
  viewFlag?:boolean
}

export interface GraphListV1 {
  id: GraphMetricsIdV1;
  title: string;
  titleSuffix?: string;
  graphType: GraphType;
  content: GraphMetricsSeriesV1[];
  layout: Partial<Layout>;
  valueFormat: GraphValueFormat;
  viewFlag?:boolean;
}


export interface GraphLegendList {
  title: string;
  value: number | null;
}